import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ExperienceEngagementsService } from '../experience-engagements.service';
import { ExperienceEngagementsCompletedEngagementsViewPart } from './completed-engagements/completed-engagements-view.part';
import { ExperienceContactReqFollowUpsViewPart } from './contact-request/contact-request-view.part';
import { ExperienceEngagementsOpenEngagementsViewPart } from './open-engagements/open-engagements-view.part';
import { ExperienceFollowUpsFollowUpsViewPart } from './scheduled-follow-ups/scheduled-follow-ups.part';
@Component({
	selector: 'experience-engagements-views-part',
	standalone: true,
	imports: [
		ExperienceFollowUpsFollowUpsViewPart,
		ExperienceContactReqFollowUpsViewPart,
		ExperienceEngagementsOpenEngagementsViewPart,
		ExperienceEngagementsCompletedEngagementsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './engagements-views.part.html',
})
export class ExperienceEngagementsViewsPart implements OnInit {

	public service = inject(ExperienceEngagementsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}